export default __webpack_public_path__ + "bdbb370db8c840f840e2a6029cafc905.png";